var _path, _path2, _path3, _path4, _ellipse, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgOrderProtection = function SvgOrderProtection(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 40,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h36v40H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.993 14.29a22.738 22.738 0 0 0-1.91-9.706c-.692.054-1.4.084-2.115.084C26.069 4.669 20.9 2.8 18 0 15.1 2.8 9.932 4.668 4.031 4.668a27.69 27.69 0 0 1-2.115-.084 22.722 22.722 0 0 0-1.909 9.705C.007 27.608 10.949 39.35 18 39.35c7.548 0 17.993-11.744 17.993-25.06z",
    fill: "#06b57e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.954 17.514h12.091a1.169 1.169 0 0 1 1.169 1.169V29a1.167 1.167 0 0 1-1.167 1.167H11.955A1.169 1.169 0 0 1 10.786 29V18.682a1.168 1.168 0 0 1 1.168-1.168z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 29.459a5.461 5.461 0 0 1-5.46-5.448V13.645a5.46 5.46 0 0 1 10.92 0v10.366A5.461 5.461 0 0 1 18 29.459zm0-18.926a3.122 3.122 0 0 0-3.12 3.114v10.366a3.12 3.12 0 0 0 6.24 0V13.647A3.12 3.12 0 0 0 18 10.532z",
    fill: "#fff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.001,
    cy: 22.333,
    rx: 1.811,
    ry: 1.807,
    fill: "#06b57e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9 26.928a.9.9 0 0 1-.905.9.9.9 0 0 1-.9-.9v-5.046a.9.9 0 0 1 .905-.9.9.9 0 0 1 .9.9z",
    fill: "#06b57e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.074 4.584c-.692.054-1.4.084-2.115.084-5.868 0-11.012-1.846-13.918-4.622v39.3c7.662 0 17.942-11.8 17.942-25.056a22.738 22.738 0 0 0-1.909-9.706z",
    fill: "#010000",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }));
};

export default SvgOrderProtection;